module.exports = __webpack_public_path__ + "img/Hummingbirds_1.a2f73dc8.png";